import { render, staticRenderFns } from "./corrosion_protection_editable_property_value.vue?vue&type=template&id=0c16cef2&"
import script from "./corrosion_protection_editable_property_value.vue?vue&type=script&lang=js&"
export * from "./corrosion_protection_editable_property_value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports